import { render, staticRenderFns } from "./DictionaryWordsRecent.vue?vue&type=template&id=96535648&scoped=true&"
import script from "./DictionaryWordsRecent.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsRecent.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryWordsRecent.vue?vue&type=style&index=0&id=96535648&scoped=true&lang=scss&"
import style1 from "./DictionaryWordsRecent.vue?vue&type=style&index=1&id=96535648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96535648",
  null
  
)

export default component.exports